import { render, staticRenderFns } from "./PanelDynamicConfig.vue?vue&type=template&id=77f409c2&"
import script from "./PanelDynamicConfig.vue?vue&type=script&lang=js&"
export * from "./PanelDynamicConfig.vue?vue&type=script&lang=js&"
import style0 from "./PanelDynamicConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports